import React from 'react';
import { Icon } from 'antd';

import {
    PageShell,
    FormCard,
    StepBadge,
    CardTitle,
    CardSubtitle,
    StyledButton,
    LoginHint,
} from '../styled';

const WHATSAPP_NUMBER = '551152866410';

const WHATSAPP_MESSAGE = 'Olá! Quero contratar o Contlabs e fazer o cadastro do meu escritório.';

const whatsappUrl = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(WHATSAPP_MESSAGE);

const MaintenanceMessage = () => {
    return (
        <PageShell>
            <FormCard>
                <StepBadge>Cadastro em manutenção</StepBadge>
                <CardTitle>Vamos fazer seu cadastro com você</CardTitle>
                <CardSubtitle>
                    O cadastro online está temporariamente em manutenção. Fale com a nossa equipe pelo
                    WhatsApp: cuidamos do seu cadastro, da configuração do escritório e tiramos todas as
                    suas dúvidas.
                </CardSubtitle>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                    <StyledButton type="primary" block>
                        <Icon type="message" /> Falar no WhatsApp
                    </StyledButton>
                </a>
                <LoginHint>
                    Já tem uma conta? <a href="/login">Entrar</a>
                </LoginHint>
            </FormCard>
        </PageShell>
    );
};

export default MaintenanceMessage;
